module.exports = __webpack_public_path__ + "img/weiter_handschrift_01.47350410.png";